import {
    GET_GType,
    ADD_GType,
    TOGGLE_GType,
    RESET_GType,
    UPDATE_GType
  } from "../actionTypes";

const communicationChannelReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_GType:
      return action.payload;

    case ADD_GType:
      return action.payload;

    case UPDATE_GType:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_GType:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_GType:
      return null;

    default:
      return state;
  }
};

export default communicationChannelReducer;
